import { FC } from 'react';
import { StyledButton } from './StyledButton';
import { useUserStatus } from '../../config/authentication/useUserStatus';
import { ProductoData } from '../../model/ProductoData';
import { CANJE_PRODUCTO_CONFIGS } from '../../constants/data';

const TOOLTIP_BLOCKED = 'No tiene puntos suficientes';
const TOOLTIP_ENABLED = 'Canjear';

const KEYBOARD_ENTER = 'Enter';

type Props = {
  title: string;
  onClick: (product?: ProductoData) => void;
  product?: ProductoData;
  blockedBackground?: string;
  blockedColor?: string;
  checkStock?: boolean;
};

export const CanjeButton: FC<Props> = ({ title, onClick, product, blockedBackground, blockedColor, checkStock }) => {
  const { isLoggedin, loginData } = useUserStatus();
  const userPoints = loginData?.user?.points;
  const productPoints = product?.puntos;

  const blocked = isLoggedin && (userPoints == null || !productPoints || userPoints < productPoints);

  const tooltip = blocked ? TOOLTIP_BLOCKED : TOOLTIP_ENABLED;

  const tipoProductoIncluyeStock =
    product?.tipoProducto && CANJE_PRODUCTO_CONFIGS && CANJE_PRODUCTO_CONFIGS.get(product.tipoProducto)?.incluyeStock;

  const onClickHandler = (event: React.UIEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    if (blocked) return;

    onClick(product);
  };

  const onKeyDownHandler = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === KEYBOARD_ENTER) {
      onClickHandler(event);
    }
  };

  if (!product?.codigo || product.codigo.length === 0) return <></>;

  if (checkStock && tipoProductoIncluyeStock && (!product?.stock || product.stock < 0)) return <></>;

  return (
    <StyledButton
      fontSize={['14px', '15px']}
      variant="none"
      borderRadius={'3px 8px 3px 8px'}
      color={blocked ? blockedColor : 'white'}
      padding={['12px 24px !important', '12px 32px !important']}
      width={'fit-content'}
      onClick={onClickHandler}
      onKeyDown={onKeyDownHandler}
      backgroundColor={blocked ? blockedBackground : 'primary.0'}
      title={tooltip}
      alt-text={tooltip}
      blocked={blocked}
    >
      {title}
    </StyledButton>
  );
};

CanjeButton.defaultProps = {
  blockedBackground: 'secondary.0',
  blockedColor: 'white',
};
